export const countryListData: CountryMeta[] = [
    {
        "countryCode": "US",
        "country": "United States",
        "states": ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"]
    },
    {
        "countryCode": "CA",
        "country": "Canada",
        "states": ["Alberta", "British Columbia", "Manitoba", "Newfoundland and Labrador", "New Brunswick", "Nova Scotia", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Nunavut", "Northwest Territories", "Yukon"]
    },
]

export type CountryMeta = {
    countryCode:string,
    country:string,
    states:string[]
}

export const getCountryData = (code: string) => {
    return countryListData.find((country) => {
        if (country.countryCode === code) {
            return country;
        }
    });
}

